import { ComboRequestDto } from "@onair/repositories";
import {
	changeStatusCombo,
	createCombo,
	deleteCombo,
	updateCombo,
	validateComboPurchase,
} from "@onair/services/combo";
import { useMutation } from "@tanstack/react-query";

const mutationCreateCombo = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: (payload: ComboRequestDto) => {
			return createCombo(payload);
		},
	});
};

const mutationUpdateCombo = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: ({ id, payload }: { id: string; payload: ComboRequestDto }) => {
			return updateCombo(id, payload);
		},
	});
};

const mutationChangeStatusCombo = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: (id: string) => {
			return changeStatusCombo(id);
		},
	});
};

const mutationDeleteCombo = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: (id: string) => {
			return deleteCombo(id);
		},
	});
};

const useValidateComboPurchaseMutation = (options = {}) => {
	return useMutation({
		...options,
		mutationFn: (comboId: string) => {
			return validateComboPurchase(comboId);
		},
	});
};

export {
	mutationCreateCombo,
	mutationDeleteCombo,
	mutationChangeStatusCombo,
	mutationUpdateCombo,
	useValidateComboPurchaseMutation,
};
